<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'aboutUs'"
    class="page"
  >
    <Header
      :setting="{
        title: '關於我們',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="align--left fs4 fc--primary ml3 mb4">
      {{ spiderman.clinic[composable.member.info.clinic].fullname }}
    </div>
    <img
      :src="info.aboutUsPictureUrl"
      alt=""
      class="image--size-x-fit mb4"
    >
    <div class="page__text align--left">
      {{ info.aboutUsContent }}
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('initialization');
    const info = ref(null);

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        info.value = (await api.introductions.get(composable.member));

        page.value = 'aboutUs';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    return {
      page,
      composable,
      info,
      spiderman,
    };
  },
};
</script>
